"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.findPrintableInProject = void 0;
exports.default = findPrintableGroup;
function findPrintableGroup(project, printableId) {
  return project.printableGroups.find(pg => pg.printables.find(p => printableId === p.id));
}
const findPrintableInProject = (project, printableId) => {
  const printableGroup = project.printableGroups.find(pg => pg.printables.find(p => printableId === p.id));
  return printableGroup ? printableGroup.printables.find(p => p.id === printableId) : undefined;
};
exports.findPrintableInProject = findPrintableInProject;